var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-slide-x-reverse-transition',[_c('v-sheet',{staticClass:"sliderDrawer",style:(_vm.style),attrs:{"tile":"","elevation":_vm.visible ? 9 : 0}},[_c('portal-target',{attrs:{"name":"sliderDrawer","multiple":"","transition":_vm.transition},on:{"change":_vm.onPortalTargetChange}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }